import React from "react";
import SkillsSection from "./hard-skills";

const Skills: React.FC = () => {
  return (
    <section id="skills" className="pt-10">
      <SkillsSection />
    </section>
  );
};

export default Skills;
